export default __webpack_public_path__ + "static/media/022-oil lamp.28591464.svg";